import PortalIdParser from 'PortalIdParser';
export const redirectTo = href => {
  window.location.href = href;
};
export const getMarketingRootUrl = () => `/marketing/${PortalIdParser.get()}`;
export const getSelectCampaignTemplateUrl = () => `${getMarketingRootUrl()}/campaigns/templates/select`;
export const getCampaignsAssetsUrl = campaignId => `${getMarketingRootUrl()}/campaigns/${campaignId}/assets`;
export const getCampaignsPerformanceUrl = campaignId => `${getMarketingRootUrl()}/campaigns/${campaignId}/performance`;